import { IStats } from "./DashboardStats";

export class DashboardStatsClass implements IStats {
    public accountPayables = { bsAmount: "0", usdAmount: "0" };
    public accountReceivables = { bsAmount: "0", usdAmount: "0" };
    public bankBalance = { accounts: [], totalBalance: "0" };
    public clients = { totalQty: "0", newInMonth: "0" };
    public dayBilling = { bsCash: "0", bsDigital: "0", copCash: "0", eurCash: "0", usdCash: "0", usdDigital: "0" };
    public grossMargin = { annualGrossMargin: "0%", monthGrossMargin: "0%" };
    public inventory = { categories: [], totalInv: "0" };
    public monthIncome = { bs: 0, usd: 0, cop: 0, eur: 0 };
    public monthOutflow = { bs: 0, usd: 0, cop: 0, eur: 0 };
    public netCashFlow = { bs: 0, usd: 0, cop: 0, eur: 0 };
    public sales = { currentMonthSales: [], salesByMonth: [] };
    public topSold = {
        products: { allYear: [], currentMonth: [] },
        services: { allYear: [], currentMonth: [] }
    };

    constructor() {
        this.accountPayables.bsAmount = "0";
        this.accountPayables.usdAmount = "0";
        this.accountReceivables.bsAmount = "0";
        this.accountReceivables.usdAmount = "0";
        this.bankBalance.accounts = [];
        this.bankBalance.totalBalance = "0";
        this.clients.totalQty = "0";
        this.clients.newInMonth = "0";
        this.dayBilling.bsCash = "0";
        this.dayBilling.bsDigital = "0";
        this.dayBilling.copCash = "0";
        this.dayBilling.eurCash = "0";
        this.dayBilling.usdCash = "0";
        this.dayBilling.usdDigital = "0";
        this.grossMargin.annualGrossMargin = "0%";
        this.grossMargin.monthGrossMargin = "0%";
        this.inventory.categories = [];
        this.inventory.totalInv = "0";
        this.monthIncome.bs = 0;
        this.monthIncome.usd = 0;
        this.monthIncome.cop = 0;
        this.monthIncome.eur = 0;
        this.monthOutflow.bs = 0;
        this.monthOutflow.usd = 0;
        this.monthOutflow.eur = 0;
        this.monthOutflow.cop = 0;
        this.netCashFlow.bs = 0;
        this.netCashFlow.usd = 0;
        this.netCashFlow.cop = 0;
        this.netCashFlow.eur = 0;
        this.sales.currentMonthSales = [];
        this.sales.salesByMonth = [];
        // this.topSold.products.allYear = [];
        // this.topSold.products.currentMonth = [];
        // this.topSold.services.allYear = [];
        // this.topSold.services.currentMonth = [];
    }
}